module.exports = __webpack_public_path__ + "static/media/atom-alt.3192f818.svg";